import { Routes } from '@angular/router';
import { CategoriseAudioToWordPage } from './categorise-audio-to-word-page/categorise-audio-to-word-page';
import { CategoriseMixedPage } from './categorise-mixed-page/categorise-mixed-page';
import { CategorisePage } from './categorise-page';
import { CategoriseWordToAudioPage } from './categorise-word-to-audio-page/categorise-word-to-audio-page';
import { CategoriseWordToImagePage } from './categorise-word-to-image-page/categorise-word-to-image-page';
import { CategoriseWordToRulePage } from './categorise-word-to-rule-page/categorise-word-to-rule-page';

export const mechanicCategoriseRoutes: Routes = [
  {
    path: '',
    component: CategorisePage,
  },
  {
    path: 'mixed',
    component: CategoriseMixedPage,
  },
  {
    path: 'audio-to-word',
    component: CategoriseAudioToWordPage,
  },
  {
    path: 'word-to-image',
    component: CategoriseWordToImagePage,
  },
  {
    path: 'word-to-audio',
    component: CategoriseWordToAudioPage,
  },
  {
    path: 'word-to-rule',
    component: CategoriseWordToRulePage,
  },
];
